import { Link } from 'react-router-dom';
import Smiley from './Smiley.jsx';
import LiveStamp from './LiveStamp.jsx';
import { WA_URL, WA_DISPLAY } from '../config.js';
import { trackWhatsApp } from '../analytics.js';

export default function Footer() {
  return (
    <footer className="foot">
      <div className="wrap foot-grid">
        <div className="foot-brand">
          <Link to="/" className="brand-mark" style={{ color: '#F6F1E6' }}>
            <Smiley size={32} />
            <span>FocusMode</span>
          </Link>
          <p>FocusMode.&#8207; גבעת השלושה, ישראל.&#8207; בניית אתרים, דפי נחיתה, מערכות ואוטומציות.</p>
        </div>
        <div>
          <h6>ניווט</h6>
          <Link to="/">דף הבית</Link>
          <Link to="/services">שירותים</Link>
          <Link to="/cases">מקרים מהשטח</Link>
          <Link to="/about">אודות</Link>
          <Link to="/contact">יצירת קשר</Link>
          <Link to="/blog">בלוג</Link>
        </div>
        <div>
          <h6>קשר ישיר</h6>
          <a href={WA_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsApp('footer')}>
            WhatsApp · {WA_DISPLAY}
          </a>
          <a href="mailto:yoav@focusmode.info">yoav@focusmode.info</a>
          <p>מענה תוך 48 שעות.&#8207; גם בסופ״ש.</p>
        </div>
      </div>
      <div className="wrap foot-bottom">
        <span>© 2026 FocusMode · focusmode.info</span>
        <LiveStamp />
        <span>FocusMode · made with care.</span>
      </div>
    </footer>
  );
}
